import { render, staticRenderFns } from "./QaDetail.vue?vue&type=template&id=5818d054&scoped=true"
import script from "./QaDetail.vue?vue&type=script&lang=js"
export * from "./QaDetail.vue?vue&type=script&lang=js"
import style0 from "./QaDetail.vue?vue&type=style&index=0&id=5818d054&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818d054",
  null
  
)

export default component.exports